import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/store';

// ------------------ 初始設定 -----------------
import firstInvite from './firstInvite';

// ------------------- 設定密碼畫面 -------------------
import passwordSetting from './passwordSetting';

// ------------------ 發票 -----------------
import invoice from './invoice';

// ------------------ 請款單 -----------------
import payment from './payment';

// ------------------- 專案 -------------------
// 專案管理、專案類型管理、客戶管理
// 委外、委外類型
import project from './project';
import serviceFeeStatement from './serviceFeeStatement';

// ------------------- 分析 -------------------
// 總覽
import analysis from './analysis';

// ------------------- 財務 -------------------
// 財務收支管理、零用現金管理、薪資管理、匯款明細查詢
// 特定費用項目、經常性費用、銀行帳戶、收支項目設定、營收目標設定【審核、公司資訊】
// 收支日曆、幣別與匯率、發票字軌管理
import finance from './finance';

// ------------------- 會計 -------------------
import accounting from './accounting';

// ------------------- 設定 -------------------
// 帳號權限、部門管理
import admin from './admin';
import tool from './tool';

const siteName = ' - Sokuji 數即';
const routes = [
    // 從會計師專區登入頁面
    {
        path: '/login-landing-page/:mno/*',
        name: 'loginLandingPage',
        component: () => import('../components/LoginLandingPage.vue'),
        meta: {
            title: `登入${siteName}`,
        },
    },

    // 根目錄導向 (依據登入狀態)
    {
        path: '/',
        component: () => import('../components/RootRouterView.vue'),
    },

    // 登入頁面
    {
        path: '/login',
        name: 'login',
        component: () => import('../components/LoginView.vue'),
        meta: {
            title: `登入${siteName}`,
        },
    },

    // 登入頁面
    {
        path: '/:company_id/login',
        name: 'login',
        component: () => import('../components/LoginView.vue'),
        meta: {
            title: `登入${siteName}`,
        },
    },

    // 登出訊息頁面
    {
        path: '/logoutMsg',
        component: () => import('../components/LogoutMsgView.vue'),
        meta: {
            title: `已登出${siteName}`,
        },
    },

    // 測試頁面
    {
        path: '/test',
        name: 'test',
        component: () => import('../components/TestView.vue'),
    },

    // 維護頁面
    {
        path: '/maintain',
        name: 'maintain',
        component: () => import('../components/MaintainView.vue'),
        meta: {
            title: `維護中${siteName}`,
        },
    },

    // QR Code 上傳單據
    {
        path: '/qr-code-uploader',
        name: 'qr-code-uploader',
        component: () => import('../components/dashboard/QrCodeUploader/indexPage.vue'),
        meta: {
            title: `QrCode上傳${siteName}`,
        },
    },

    // 設定密碼畫面
    ...passwordSetting(siteName),

    // 第一次啟用引導設定介面
    ...firstInvite(siteName),

    // 主畫面
    {
        path: '/:company_id',
        component: () => import('../components/dashboard/DashboardView.vue'),
        redirect: '/:company_id/index',
        meta: {
            requiresAuth: true,
        },

        // 註冊各分頁元件
        children: [
            // 首頁
            {
                path: 'index',
                name: 'index',
                component: () => import('../components/dashboard/Index/IndexPage.vue'),
                meta: {
                    title: `我的首頁${siteName}`,
                },
            },

            // 個人資訊
            {
                path: 'profile',
                name: 'profile',
                component: () => import('../components/dashboard/Profile/ProfilePage.vue'),
                meta: {
                    title: `個人資料${siteName}`,
                },
            },

            // 發票
            ...invoice(siteName),

            // 請款
            ...payment(siteName),

            // 專案 - 專案管理、客戶管理、委外、專案類型、委外類型
            ...project(siteName),

            //
            ...serviceFeeStatement(siteName),

            // 分析
            ...analysis(siteName),

            // 財務
            ...finance(siteName),

            // 會計
            ...accounting(siteName),

            // 帳號權限管理
            ...admin(siteName),

            // 工具
            ...tool(siteName),

            // tutorial
            {
                path: 'tutorial',
                name: 'tutorial',
                component: () => import('../components/dashboard/Tutorial/index.vue'),
                meta: {
                    title: `使用教學${siteName}`,
                },
            },
        ],
    },
];

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: __dirname,

    // 註冊各個頁面名稱、對應元件
    routes,

    // 設定跳頁後的滾動行為
    // 無特別指定位置，就跳回頁首
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    },
});

// 每頁進入時登入檢查
router.beforeEach((to, from, next) => {
    // 設定 title
    if (to.meta.title) {
        document.title = to.meta.title;
    }

    // 更新通知
    // store.dispatch("updateNotification")

    // 如果分頁設定為需要登入權限(requiresAuth)，則檢查 store 是否已有登入資訊
    // 否則跳到登入頁面
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters['account/isLoggedIn']) {
            next();
        } else {
            next({
                path: '/login',
                query: {
                    url: to.fullPath, // 原本預計要前往的頁面網址
                },
            });
        }
    } else {
        next();
    }

    if (from.name?.includes('accounting-business-tax') && !to.name?.includes('accounting-business-tax')) {
        // 去除申報營業稅選項
        localStorage.removeItem('401-selected-invoice');
        localStorage.removeItem('401-selected-payment');
    }
});

export default router;
